import * as actions from "constants/userConstants";
import axios from "axios";
import config from "utils/config";
import redirect from "utils/redirect";
import { getCart } from "./cartActions";
import { getLikedProduct } from "./productActions";
import { getAddress } from "./addressActions";
import ReactGA from "react-ga";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { RentripsURL } from "utils/request";

export const getUser = () => async (dispatch: any) => {
  try {
    dispatch({
      type: actions.USER_GET_REQUEST,
    });

    const { data } = await axios.get(RentripsURL +"/api/auth/", {
      withCredentials: true,
    });

    dispatch({
      type: actions.USER_GET_SUCCESS,
      payload: data,
    });

    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error: any) {
    dispatch({
      type: actions.USER_GET_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const userRegister =
  (name: string, email: string, password: string, phone?: string) =>
  async (dispatch: any) => {
    try {
      dispatch({
        type: actions.USER_REGISTER_REQUEST,
      });

      const { data } = await axios.post(RentripsURL +"/api/auth/register", {
        name,
        email,
        password,
        phone,
      });

      dispatch({
        type: actions.USER_REGISTER_SUCCESS,
        payload: data,
      });

      dispatch({
        type: actions.USER_LOGIN_SUCCESS,
        payload: data,
      });

      dispatch(getCart());
      dispatch(getLikedProduct());
      dispatch(getAddress());
      dispatch(getUserProfile());

      logging("", {
        category: "user",
        action: "register",
        target: data.id,
      });

      eventAnalytic({
        category: "User",
        action: "Register",
        label: `${data.id || data._id}`,
      });

      localStorage.setItem("userInfo", JSON.stringify(data));
    } catch (error: any) {
      eventAnalytic({
        category: "User",
        action: "Register failed",
      });
      dispatch({
        type: actions.USER_REGISTER_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const userLogin =
  (email: string, password: string) => async (dispatch: any) => {
    try {
      // Event user try to login
      dispatch({
        type: actions.USER_LOGIN_REQUEST,
      });

      const { data } = await axios.post(RentripsURL +"/api/auth/login", {
        email,
        password,
      });

      dispatch({
        type: actions.USER_LOGIN_SUCCESS,
        payload: data,
      });

      dispatch(getCart());
      dispatch(getLikedProduct());
      dispatch(getAddress());
      dispatch(getUserProfile());

      logging("", {
        category: "user",
        action: "login",
        target: data.id,
      });

      ReactGA.event({
        category: "User",
        action: `Login`,
        label: `${data.id || data._id}`,
      });

      localStorage.setItem("userInfo", JSON.stringify(data));
    } catch (error: any) {
      ReactGA.send({ category: "Auth", action: `Login failed` });
      dispatch({
        type: actions.USER_LOGIN_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const userLogout = () => async (dispatch: any, getState: any) => {
  const { token, id } = getState().userInfo.userInfo || "";

  try {
    dispatch({
      type: actions.USER_LOGOUT_SUCCESS,
    });

    logging(token, {
      category: "user",
      action: "logout",
      target: id,
    });

    await axios.get(RentripsURL +"/api/auth/logout");
    document.location.href = "/login";

    localStorage.removeItem("userInfo");
    localStorage.removeItem("ongoingOrder");
    localStorage.removeItem("addresses");
    localStorage.removeItem("likedProduct");
    localStorage.removeItem("cartItems");
  } catch (error: any) {
    dispatch({
      type: actions.USER_LOGIN_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getUserProfile = () => async (dispatch: any, getState: any) => {
  const { token } = getState().userInfo.userInfo;

  logging(token, {
    category: "profile",
    action: "view",
  });

  try {
    dispatch({
      type: actions.USER_PROFILE_REQUEST,
    });

    const { token } = getState().userInfo.userInfo;
    const { data } = await axios.get(RentripsURL +`/api/user/profile`, config(token));

    dispatch({ type: actions.USER_PROFILE_REQUEST_SUCCESS, payload: data });
  } catch (error: any) {
    dispatch({
      type: actions.USER_PROFILE_REQUEST_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    redirect(error, dispatch);
  }
};

export const updateProfile =
  (
    fullName: string,
    displayName?: string,
    gender?: string,
    email?: string,
    // birthday?: Date | string,
    phone?: string,
    // Sorry Bad Practice, phone aku isi ? karena kalo tidak bakal error entah kenapa
    description?: string,
    avatar?: string
  ) =>
  async (dispatch: any, getState: any) => {
    const { userInfo } = getState().userInfo;
    const { token } = getState().userInfo.userInfo;

    logging(token, {
      category: "profile",
      action: "update",
    });

    try {
      dispatch({
        type: actions.USER_PROFILE_UPDATE_REQUEST,
      });

      const { data } = await axios.patch(
        RentripsURL +`/api/user/profile/`,
        {
          fullName,
          displayName,
          gender,
          email,
          // birthday,
          phone,
          description,
          avatar,
        },
        config(token)
      );

      await dispatch({
        type: actions.USER_PROFILE_UPDATE_SUCCESS,
        payload: data,
      });

      setTimeout(() => {
        dispatch({ type: actions.USER_PROFILE_REQUEST_SUCCESS, payload: data });
      }, 1000);

      userInfo.avatar = avatar;
      userInfo.name = fullName;

      dispatch({
        type: actions.USER_LOGIN_SUCCESS,
        payload: userInfo,
      });

      eventAnalytic({
        category: "User",
        action: "Update Profile ",
        label: `${userInfo?.id || userInfo._id}`,
      });

      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    } catch (error: any) {
      eventAnalytic({
        category: "User",
        action: "Update Profile failed",
        label: `${userInfo?.id || userInfo._id}`,
      });
      dispatch({
        type: actions.USER_PROFILE_UPDATE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      redirect(error, dispatch);
    }
  };

export const updatePassword =
  (password: string, newPassword: string) =>
  async (dispatch: any, getState: any) => {
    const { token } = getState().userInfo.userInfo;

    logging(token, {
      category: "user",
      action: "update-password",
    });

    try {
      dispatch({
        type: actions.USER_PASSWORD_UPDATE_REQUEST,
      });

      await axios.post(
        RentripsURL +"/api/user/password",
        {
          password,
          newPassword,
        },
        config(token)
      );

      dispatch({
        type: actions.USER_PASSWORD_UPDATE_SUCCESS,
      });
    } catch (error: any) {
      dispatch({
        type: actions.USER_PASSWORD_UPDATE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      redirect(error, dispatch);
    }
  };

export const addSubscriber =
  (email: string) => async (dispatch: any, getState: any) => {
    const { token } = getState().userInfo.userInfo;

    logging(token, {
      category: "user",
      action: "subscribe",
    });

    try {
      dispatch({
        type: actions.USER_SUBSCRIBE_REQUEST,
      });

      const { data } = await axios.post(RentripsURL +"/mail/", email);

      dispatch({
        type: actions.USER_SUBSCRIBE_SUCCESS,
        payload: data,
      });

      localStorage.setItem("subscribedUser", JSON.stringify(data));
    } catch (error: any) {
      dispatch({
        type: actions.USER_SUBSCRIBE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateUserPassword =
  (password: string, token: string) => async (dispatch: any) => {

    logging("", {
      category: "user",
      action: "update-forget-password",
    });
    
    try {
      dispatch({
        type: actions.USER_FORGET_PASSWORD_UPDATE_REQUEST,
      });

      const { data } = await axios.put(RentripsURL +`/api/user/password?token=${token}`, {
        password,
      });

      dispatch({
        type: actions.USER_FORGET_PASSWORD_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      dispatch({
        type: actions.USER_FORGET_PASSWORD_UPDATE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
